var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCancel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cancel",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12024",
    "data-name": "Group 12024",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12023",
    "data-name": "Group 12023"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5541",
    "data-name": "Path 5541",
    d: "M18.783,3.287a11,11,0,1,0,0,15.564A11.014,11.014,0,0,0,18.783,3.287ZM17.578,17.646a9.3,9.3,0,1,1,0-13.153A9.308,9.308,0,0,1,17.578,17.646Z",
    transform: "translate(0 -0.07)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12026",
    "data-name": "Group 12026",
    transform: "translate(7.267 7.162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12025",
    "data-name": "Group 12025"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5542",
    "data-name": "Path 5542",
    d: "M174.569,170.956l-2.363-2.359,2.363-2.359a.835.835,0,1,0-1.18-1.181l-2.364,2.361-2.364-2.361a.835.835,0,1,0-1.18,1.181l2.363,2.359-2.363,2.359a.835.835,0,0,0,1.18,1.181l2.364-2.361,2.364,2.361a.835.835,0,1,0,1.18-1.181Z",
    transform: "translate(-167.236 -164.813)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancel);
export default __webpack_public_path__ + "static/media/icon_cancel.ad360101e729c8c3619386e53b0a9411.svg";
export { ForwardRef as ReactComponent };